export enum OfferChangeTypes {
	CHANGE = 'change',
	ADD = 'add',
	CONFIG = 'config',
}

export const OfferAddOrConfigTypes = [OfferChangeTypes.ADD, OfferChangeTypes.CONFIG];
